frappe.provide('jhaudio.designer');

const STATE_SEARCH = "search";
const STATE_NEWOWNER = "new-owner";

jhaudio.designer.PersonalizeForm = class {
  constructor($container, controller, personalizeOnly) {
    this.personalizeOnly = !!personalizeOnly;
    this.$container = $container;
    this.controller = controller;
    this.validate_case = controller.validate_case != undefined?controller.validate_case:true;
    this.init();
  }

  async init() {
    const me = this;
    this.$impressionSearchContainer = this.$container.find('.impression-search-box');
    this.$impressionIdSearch = this.$container.find('[name=impression_id]');
    this.$impressionResults = this.$container.find('.impression-search-results');
    this.$impressionNewOwner = this.$container.find('.new-iem-owner-btn');
    this.$firstNameInput = this.$container.find('[name=owner_first_name]');
    this.$lastNameInput = this.$container.find('[name=owner_last_name]');
    this.$bandInput = this.$container.find('[name=band_name]');
    this.$emailInput = this.$container.find('[name=owner_email]');
    this.$emailedit = this.$container.find('.owner_email_edit');
    this.$emailsave = this.$container.find('.owner_email_save');
    this.$emailedit.parent().css('position', 'relative');
    this.$emailsave.hide();
    this.$measurementsDropdown = this.$container.find('[name=owner_measurements]');
    this.$measurementsSection = this.$container.find('.measurement-section');

    if (!this.personalizeOnly) {
      this.$nameOnCaseRow = this.$container.find('.name_on_case-row');
      this.$nameOnCaseInput = this.$container.find('[name=name_on_case]');
      this.$qtyInput = this.$container.find('[name=qty]');
      this.$instructionsInput = this.$container.find('[name=instructions]');
      this.$rushDropdown = this.$container.find('[name=rush_item]');
      this.$shipDateInput = this.$container.find('[name=ship_date]');
    } else {
      me.validate_case = false;
    }

    let hasState = false;

    if (this.controller.state.personalization.iem_owner) {
      const owner = this.controller.iem_owners.find((i) => i.name == this.controller.state.personalization.iem_owner);
      if (owner) {
        this.$impressionIdSearch.val(owner.impression_id);
        me.iem_owner_impression_id = owner.impression_id;
        me.iem_owner = owner.name;
        me.$firstNameInput.prop('disabled', true);
        me.$lastNameInput.prop('disabled', true);
        me.$emailInput.prop('disabled', true);
        me.$measurementsDropdown.prop('disabled', true);
      }
    }

    let hide_owner_fields = true;
    if (this.controller.state.personalization.first_name) {
      hasState = true;
      hide_owner_fields = false;
      this.$firstNameInput.val(this.controller.state.personalization.first_name);
    }
    if (this.controller.state.personalization.last_name) {
      hide_owner_fields = false;
      hasState = true;
      this.$lastNameInput.val(this.controller.state.personalization.last_name);
    }
    if (this.controller.state.personalization.band_name) {
      hasState = true;
      this.$bandInput.val(this.controller.state.personalization.band_name);
    }
    if (this.controller.state.personalization.email_id) {
      hasState = true;
      hide_owner_fields = false;
      this.$emailInput.val(this.controller.state.personalization.email_id);
    }
    if (this.controller.state.personalization.measurements) {
      hasState = true;
      hide_owner_fields = false;
      this.$measurementsDropdown.val(this.controller.state.personalization.measurements);
    }

    if (!this.personalizeOnly) {
      if (this.controller.state.personalization.name_on_case) {
        hasState = true;
        this.$nameOnCaseInput.val(this.controller.state.personalization.name_on_case);
      }
      if (this.controller.state.personalization.qty) {
        hasState = true;
        this.$qtyInput.val(this.controller.state.personalization.qty || 1);
      }
      if (this.controller.state.personalization.instructions) {
        hasState = true;
        this.$instructionsInput.val(this.controller.state.personalization.instructions);
      }
      if (this.controller.state.personalization.rush_item) {
        hasState = true;
        this.$rushDropdown.val(this.controller.state.personalization.rush_item);
      }
    }

    if (this.controller.on !== undefined) {
      this.controller.on('validate-form', function () {
        if (!me.personalizeOnly) {
          if (!me.controller.iemRequiresCase()) {
            me.$nameOnCaseRow.hide();
            me.validate_case = false;
          } else {
            me.$nameOnCaseRow.show();
            me.validate_case = true;
          }
        } else {
          me.$nameOnCaseRow.show();
          me.validate_case = true;
        }
      });
    }

    if (hide_owner_fields) {
      me.$firstNameInput.hide();
      me.$lastNameInput.hide();
      me.$emailInput.hide();
      me.$emailedit.hide();
      me.$emailsave.hide();
      me.$measurementsSection.hide();
    }

    if (this.$impressionIdSearch) {
      let debounceHandler = null;
      const debouncer = function (timeout, callback, handlerIn) {
        if (handlerIn) {
          clearTimeout(handlerIn);
        }

        return setTimeout(callback, timeout);
      }

      me.iem_owner_impression_id = undefined;
      me.ui_state = STATE_SEARCH;

      if (frappe.user_id == "Guest") {
        me.ui_state = STATE_NEWOWNER;
        me.$impressionIdSearch.hide();
        me.$firstNameInput.show();
        me.$lastNameInput.show();
        me.$emailInput.show();
        me.$measurementsSection.show();
      }

      this.$impressionNewOwner.click(function (e) {
        if (debounceHandler) {
          clearTimeout(debounceHandler);
        }
        me.$impressionIdSearch.attr('placeholder', "New IEM Owner");
        me.ui_state = STATE_NEWOWNER;
        me.iem_owner = undefined;
        me.iem_owner_impression_id = undefined;

        me.$firstNameInput.val("").change().show();
        me.$lastNameInput.val("").change().show();
        me.$emailInput.val("").change().show();
        me.$measurementsDropdown.val("no").change();
        me.$measurementsSection.show();
        me.$impressionIdSearch.val("").change();
        me.$impressionSearchContainer.addClass('new-owner');

        me.$firstNameInput.prop('disabled', false);
        me.$lastNameInput.prop('disabled', false);
        me.$emailInput.prop('disabled', false);
        me.$measurementsDropdown.prop('disabled', false);

        me.$impressionResults.find('.results-rows').empty();
        me.$impressionResults.removeClass("open");
        me.$impressionSearchContainer.removeClass('open');

        me.$firstNameInput.focus().scrollTop();
        me.iem_new_owner = true;

        e.preventDefault();
        return false;
      });

      const closeSearch = () => {
        // if we already have an iem owner selected just close the search box
        if (me.iem_owner) {
          me.$impressionIdSearch.val(me.iem_owner_impression_id).change();
        } else {
          me.$impressionIdSearch.val("").change();
        }
        if (debounceHandler) {
          clearTimeout(debounceHandler);
        }
        me.$impressionResults.find('.results-rows').empty();
        me.$impressionResults.removeClass("open");
        me.$impressionSearchContainer.removeClass('open');
        me.$impressionSearchContainer.find('.search-wait').hide();
      }

      this.$impressionSearchContainer.find('.back').click(function (e) {
        closeSearch();
        e.preventDefault();
        return false;
      });

      this.$impressionIdSearch.bind("keydown", function (e) {
        if (e.key == "Escape") {
          closeSearch();
          e.preventDefault();
          return false;
        }
      }).bind("input propertychange focus", async function (e) {
        $(this).attr('placeholder', "Search IEM Owner or Impression #");
        // handle input value
        let text = $(this).val();
        // handle copy/paste value
        const paste = e.originalEvent.clipboardData ? e.originalEvent.clipboardData.getData('text') : '';
        // combine input and paste value as it is not combined until after this event
        text += paste;

        // Hide iem owner field if there is no data on them
        if (!me.$firstNameInput.val()) {
          me.$firstNameInput.hide();
        }
        if (!me.$lastNameInput.val()) {
          me.$lastNameInput.hide();
        }
        if (!me.$emailInput.val()) {
          me.$emailInput.hide();
          me.$emailedit.hide();
          me.$emailsave.hide();
        }

        // always open the search box when entering data
        me.$impressionResults.addClass('open');
        me.$impressionSearchContainer.addClass('open');
        //me.$impressionResults.find('.results-rows').empty();
        //me.$impressionResults.find('.results-rows').text('<div class="searching">Searching...</div>');

        // debounce calls to backend to wait until user stops typing for 500ms
        me.$impressionSearchContainer.find('.search-wait').show();
        debounceHandler = debouncer(300, async function () {
          const r = await frappe.call("jhaudio.designer.api.search_iem_owner", { text })
          me.$impressionSearchContainer.find('.search-wait').hide();

          if (r.message) {
            me.$impressionResults.find('.results-rows').empty();
            for (const result of r.message) {
              const $row = $(`
              <div class="result-row">
                <div class="r-left">
                  <div class="result-impression-id"><span>Impression #:</span> <span>${result.impression_id}</span></div>
                  <div class="result-name"><span>Name:</span> <span>${result.last_name}, ${result.first_name}<span></div>
                  <div class="result-email-id"><span>Email:</span> <span>${result.email_id}</span></div>
                </div>
                <div class="r-right">
                  <input type="checkbox" />
                </div>
              </div>`);

              me.$impressionResults.find('.results-rows').append($row);
              $row.data('iem-owner', result);
              $row.click(function () {
                const owner = $(this).data('iem-owner');
                me.ui_state = STATE_SEARCH;
                me.$impressionSearchContainer.removeClass('new-owner');

                me.$firstNameInput.val(owner.first_name || "").change().show();
                me.$lastNameInput.val(owner.last_name || "").change().show();
                me.$emailInput.val(owner.email_id || "").change().show();
                if (owner.impression_id > 0) {
                  me.$measurementsDropdown.val("yes").change();
                } else {
                  me.$measurementsDropdown.val("no").change();
                }
                me.$measurementsSection.show();
                me.$impressionIdSearch.val(owner.impression_id).change();
                me.iem_owner_impression_id = owner.impression_id;
                me.iem_owner = owner.name;

                // don't let users edit exiting IEM Owners
                me.$firstNameInput.prop('disabled', true);
                me.$lastNameInput.prop('disabled', true);
                me.$emailInput.prop('disabled', true);
                me.$measurementsDropdown.prop('disabled', true);

                me.$impressionResults.find('.results-rows').empty();
                me.$impressionResults.removeClass('open');
                me.$impressionSearchContainer.removeClass('open');

                me.$firstNameInput.change();
                me.$lastNameInput.change();
                me.$emailInput.change();
                me.$emailedit.show();
                me.$measurementsDropdown.change();
              });
            }
            me.$impressionResults.addClass("open");
          }
        }, debounceHandler);
      }).on('blur', function () {
        // close search box when clicking out of the dropdown
        // We add a timeout to not interfere with search result clicks
        setTimeout(() => {
          if (me.ui_state == STATE_SEARCH) {
            me.$impressionSearchContainer.removeClass('new-owner');
            if (!me.iem_owner) {
              me.$impressionIdSearch.val("").change();
            } else {
              me.$impressionIdSearch.val(me.iem_owner_impression_id).change();
            }
            me.$impressionIdSearch.attr('placeholder', "Search IEM Owner or Impression #");
          } else {
            me.$impressionSearchContainer.addClass('new-owner');
            me.$impressionIdSearch.attr('placeholder', "New IEM Owner");

            me.$firstNameInput.show().prop('disabled', false);
            me.$lastNameInput.show().prop('disabled', false);
            me.$emailInput.show().prop('disabled', false);
            me.$emailedit.hide();
            me.$emailsave.hide();
            me.$measurementsSection.show();
            me.$measurementsDropdown.prop('disabled', false);
          }

          me.$impressionSearchContainer.find('.search-wait').hide();
          me.$impressionResults.find('.results-rows').empty();
          me.$impressionResults.removeClass("open");
          me.$impressionSearchContainer.removeClass('open');
        }, 300);
      });
    }

    this.$firstNameInput.change(function () {
      me.first_name = me.fieldValue($(this));
      me.controller.validate(me);
    }).change();
    this.$lastNameInput.change(function () {
      me.last_name = me.fieldValue($(this));
      me.controller.validate(me);
    }).change();
    this.$bandInput.change(function () {
      me.band_name = me.fieldValue($(this));
      me.controller.validate(me);
    }).change();
    this.$emailInput.change(function () {
      me.email_id = me.fieldValue($(this));
      me.controller.validate(me);
    }).change();
    this.$emailedit.click(function () {
      me.$emailInput.prop("disabled", false);
      me.$emailInput.focus();
      me.$emailsave.show();
      me.$emailedit.hide();
    })
    this.$impressionIdSearch.change(function() {
      me.fieldValue($(this));
      me.controller.validate(me);
    })

    this.$emailsave.click(async function () {
      await me.saveEmail();
    })

    if (!me.personalizeOnly) {
      this.$nameOnCaseInput.change(function () {
        me.name_on_case = me.fieldValue($(this));
        me.controller.validate(me);
      }).change();
      this.$qtyInput.change(function () {
        me.qty = me.fieldValue($(this));
        me.controller.validate(me);
      }).change();
      this.$instructionsInput.change(function () {
        me.instructions = me.fieldValue($(this));
        me.controller.validate(me);
      }).change();
      this.$shipDateInput.change(function () {
        me.ship_date = me.fieldValue($(this));
        me.controller.validate(me);
      }).change();
      this.$measurementsDropdown.change(function () {
        me.measurements = me.fieldValue($(this));
        me.controller.validate(me);
      }).change();
      this.$rushDropdown.change(function () {
        me.rush_item = me.fieldValue($(this));
        me.controller.validate(me);
        if (me.controller.updatePrice) {
          me.controller.updatePrice(me);
        }
      }).change();
    }
  }

  fieldValue($field) {
    const tag = $field.prop("tagName");
    const $fieldContainer = $field.closest('.field');
    const isRequired = $fieldContainer.hasClass('is_required');
    let value = undefined;

    switch (tag) {
      case "SELECT": value = $field.find("option:selected").val(); break;
      case "INPUT":
      default: value = $field.val(); break;
    }

    if (value) {
      $fieldContainer.removeClass('error animate__bounce');
    }

    return value;
  }

  validateFields(fields) {
    for (let $field of fields) {
      if ( !$field ) {
        continue;
      }

      const tag = $field.prop("tagName");
      const $fieldContainer = $field.closest('.field');
      const isRequired = $fieldContainer.hasClass('is_required');
      let value = undefined;

      switch (tag) {
        case "SELECT": value = $field.find("option:selected").val(); break;
        case "INPUT":
        default: value = $field.val(); break;
      }

      if (!value && isRequired) {
        $fieldContainer
          .addClass('error animate__bounce')
          .one('animationend', function () {
            $(this).removeClass('animate__bounce');
          });
      } else {
        $fieldContainer.removeClass('error animate__bounce');
      }

    }
  }

  /**
   * Returns true or false if all required fields validate.
   */
  validate() {
    let valid_case = true;
    if (this.validate_case) {
      valid_case = !!this.name_on_case;
    }
    return valid_case && !!this.first_name && !!this.last_name && !!this.email_id && !!this.qty;
  }

  /**
   * Triggers all automated field validations.
   */
  fieldFeedback() {
    this.validateFields([
      this.$nameOnCaseInput,
      this.$firstNameInput,
      this.$lastNameInput,
      this.$bandInput,
      this.$emailInput,
      this.$qtyInput,
      this.$instructionsInput,
      this.$shipDateInput,
      this.$measurementsDropdown,
      this.$rushDropdown,
      this.$impressionIdSearch
    ]);
  }

  /**
   * Called before form is submitted to invoke any last async calls
   */
  async onSubmitForm() {
    // save email value changes if any
    let allow = await this.saveEmail();

    if (allow) {
      this.$emailedit.attr('disabled', true);
      this.$emailsave.attr('disabled', true);
    }

    return allow;
  }

  async onSubmitFormCompleted() {
    this.$emailedit.attr('disabled', false);
    this.$emailsave.attr('disabled', false);
  }

  /**
   * Triggers IEM Owner email update if email field is enabled.
   * Only returns false if email update goes wrong.
   */
  async saveEmail() {
    const me = this;
    // don't save email if email field is disabled
    if (this.$emailInput.attr("disabled")) {
      return true;
    }

    if (this.ui_state = STATE_NEWOWNER) {
      return true;
    }

    this.$emailInput.attr("disabled", true);
    this.$emailsave.hide();

    try {
      const res = await frappe.xcall(
        "jhaudio.cart.update_iem_email_in_iem",
        {
          "iem_owner": me.iem_owner,
          "iem_email": me.$emailInput.val()
        },
      );

      if (res.success) {
        me.$emailedit.show();
        return true;
      } else {
        frappe.msgprint(res.error);
        this.$emailedit.hide();
        this.$emailsave.show();
        this.$emailInput.attr("disabled", false);
        this.$emailInput.addClass('error animate__bounce')
          .one('animationend', function () {
            $(this).removeClass('animate__bounce');
          });

        return false;
      }

    } catch (err) {
      console.error(err);
      frappe.msgprint("There was an unexpected error while updating email address. Please contact support to help you update it.");

      this.$emailedit.hide();
      this.$emailsave.show();
      this.$emailInput.attr("disabled", false);
      return false;
    }
  }
}
